import HotRadio from '@space-core/components/form/radio'
import styled from 'styled-components'

export const Radio = styled(HotRadio)<{ $isDarkMode: boolean }>`
  .hot-form__input:checked ~ .hot-form__label::before {
    background-color: ${(props) =>
      props.$isDarkMode ? 'var(--gray-100)' : 'var(--gray-900)'}!important;
  }

  .hot-form__input:hover ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--spacer-2) var(--gray-400) !important;
  }

  .hot-form__input:focus ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-400),
      0 0 0 calc(var(--spacer-1) - var(--input-border-width)) var(--white),
      0 0 0 calc(var(--spacer-1) + var(--input-border-width)) var(--gray-900) !important;
  }

  .hot-form__input:active ~ .hot-form__label::before {
    background-color: var(--gray-600) !important;
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900) !important;
  }

  .hot-form__input:checked ~ .hot-form__label::before {
    box-shadow: 0 0 0 var(--input-border-width) var(--gray-900);
  }
`
